import { IComponentType } from '@r3f-component-data-structure';
import { isAbstractComponent } from '@r3f/utils/general';
import { getWorldPositionForScreenEntity } from '../components/r3f/Hotspots/hotspotUtils';
import { maths } from './maths';
export const getSpatialEntityRotations = (componentsById) => {
    const cnRotations = {};
    Object.keys(componentsById).forEach((id) => {
        const component = componentsById[id];
        if (!isAbstractComponent(component)) {
            cnRotations[id] = component.rotation;
        }
    });
    return cnRotations;
};
export const getSpatialEntityScales = (componentsById) => {
    const cnScales = {};
    Object.keys(componentsById).forEach((id) => {
        const { type } = componentsById[id];
        if (type !== IComponentType.Root && type !== IComponentType.Scene) {
            cnScales[id] = componentsById[id].scale;
        }
    });
    return cnScales;
};
export const getSpatialEntityPositions = (componentsById) => {
    const cnPositions = {};
    Object.keys(componentsById).forEach((id) => {
        const { type } = componentsById[id];
        if (type !== IComponentType.Root && type !== IComponentType.Scene) {
            cnPositions[id] = componentsById[id].position;
        }
    });
    return cnPositions;
};
export const getSelectedContentDocPositions = (selectedEntityIds, contentPositions) => {
    const selectedContentPositions = {};
    for (let i = 0; i < selectedEntityIds.length; i++) {
        selectedContentPositions[selectedEntityIds[i]] = contentPositions[selectedEntityIds[i]];
    }
    return selectedContentPositions;
};
export const getSelectedContentDocRotations = (selectedEntityIds, contentRotations) => {
    const selectedContentRotations = {};
    for (let i = 0; i < selectedEntityIds.length; i++) {
        selectedContentRotations[selectedEntityIds[i]] = contentRotations[selectedEntityIds[i]];
    }
    return selectedContentRotations;
};
export const getSelectedEditorDocRotations = (selectedEntityIds, editorRotations) => {
    const selectedEditorRotations = {};
    for (let i = 0; i < selectedEntityIds.length; i++) {
        selectedEditorRotations[selectedEntityIds[i]] = editorRotations[selectedEntityIds[i]];
    }
    return selectedEditorRotations;
};
export const getSelectedTransientPositions = (selectedEntityIds, transientPositions) => {
    const selectedTransientPositions = {};
    for (let i = 0; i < selectedEntityIds.length; i++) {
        selectedTransientPositions[selectedEntityIds[i]] = transientPositions[selectedEntityIds[i]];
    }
    return selectedTransientPositions;
};
export const getBoundary = (args) => {
    const { selectedEntityIds, transientPositions, transientRotations, transientScales, activeSceneId, componentsById, scene, groupInversionByAxis, contentPositions, contentRotations, contentScales } = args;
    // if (!selectedEntityIds.length) return null;
    let accMin = [];
    let accMax = [];
    for (let i = 0; i < selectedEntityIds.length; i++) {
        const id = selectedEntityIds[i];
        const position = transientPositions[id] || contentPositions[id] || [0, 0, 0];
        const rotation = transientRotations[id] || contentRotations[id] || [0, 0, 0];
        const scale = transientScales?.[id] || contentScales[id] || [1, 1, 1];
        const worldPosition = getWorldPositionForScreenEntity(id, activeSceneId, componentsById, position, scene) ?? position;
        const hotspotCoords = maths.localToWorldPosition2d(rotation[2], [worldPosition[0], worldPosition[1]], [
            [-scale[0], scale[1]],
            [0, scale[1]],
            [scale[0], scale[1]],
            [scale[0], 0],
            [scale[0], -scale[1]],
            [0, -scale[1]],
            [-scale[0], -scale[1]],
            [-scale[0], 0],
        ]);
        //TODO: refactor below priority setting
        hotspotCoords[0][2] = 0.007;
        hotspotCoords[1][2] = 0.008;
        hotspotCoords[2][2] = 0.009;
        hotspotCoords[3][2] = 0.007;
        hotspotCoords[4][2] = 0.006;
        hotspotCoords[5][2] = 0.005;
        hotspotCoords[6][2] = 0.005;
        hotspotCoords[7][2] = 0.005;
        if (selectedEntityIds.length === 1) {
            return hotspotCoords;
        }
        const currMin = [
            Math.min(hotspotCoords[0][0], hotspotCoords[2][0], hotspotCoords[4][0], hotspotCoords[6][0]),
            Math.min(hotspotCoords[0][1], hotspotCoords[2][1], hotspotCoords[4][1], hotspotCoords[6][1]),
            0,
        ];
        const currMax = [
            Math.max(hotspotCoords[0][0], hotspotCoords[2][0], hotspotCoords[4][0], hotspotCoords[6][0]),
            Math.max(hotspotCoords[0][1], hotspotCoords[2][1], hotspotCoords[4][1], hotspotCoords[6][1]),
            0,
        ];
        if (i === 0) {
            accMin = currMin;
            accMax = currMax;
        }
        else {
            accMin = [currMin[0] < accMin[0] ? currMin[0] : accMin[0], currMin[1] < accMin[1] ? currMin[1] : accMin[1], 0];
            accMax = [currMax[0] > accMax[0] ? currMax[0] : accMax[0], currMax[1] > accMax[1] ? currMax[1] : accMax[1], 0];
        }
    }
    const inv = [...groupInversionByAxis];
    const xCenter = (accMax[0] + accMin[0]) / 2;
    const yCenter = (accMax[1] + accMin[1]) / 2;
    return [
        [inv[0] && inv[1] ? accMax[0] : accMin[0], inv[0] && inv[1] ? accMin[1] : accMax[1], 0.007], //top left
        [xCenter, inv[1] ? accMin[1] : accMax[1], 0.008], // top center
        [inv[0] && inv[1] ? accMin[0] : accMax[0], inv[0] && inv[1] ? accMin[1] : accMax[1], 0.009], //top right
        [inv[0] ? accMin[0] : accMax[0], yCenter, 0.007], // right center
        [inv[0] && inv[1] ? accMin[0] : accMax[0], inv[0] && inv[1] ? accMax[1] : accMin[1], 0.006], //bottom right
        [xCenter, inv[1] ? accMax[1] : accMin[1], 0.005], //bottom center
        [inv[0] && inv[1] ? accMax[0] : accMin[0], inv[0] && inv[1] ? accMax[1] : accMin[1], 0.005], //bottom left
        [inv[0] ? accMax[0] : accMin[0], yCenter, 0.005], //left center
    ];
};
export const getSelectionScale = (selectedEntityIds, editorScales, contentScales, boundary) => {
    switch (selectedEntityIds.length) {
        case 0:
            return null;
        case 1:
            return editorScales?.[selectedEntityIds[0]] || contentScales[selectedEntityIds[0]];
        default: {
            const scale = [0, 0, 0];
            scale[0] = Math.sqrt(Math.pow(boundary[0][0] - boundary[2][0], 2) + Math.pow(boundary[0][1] - boundary[2][1], 2)) / 2;
            scale[1] = Math.sqrt(Math.pow(boundary[2][0] - boundary[4][0], 2) + Math.pow(boundary[2][1] - boundary[4][1], 2)) / 2;
            return scale;
        }
    }
};
export const getScale = (selectedEntityIds, editorScales, contentScales, boundary) => {
    switch (selectedEntityIds.length) {
        case 0:
            return null;
        case 1:
            return editorScales?.[selectedEntityIds[0]] || contentScales[selectedEntityIds[0]];
        default: {
            const scale = [0, 0, 0];
            scale[0] = Math.sqrt(Math.pow(boundary[0][0] - boundary[2][0], 2) + Math.pow(boundary[0][1] - boundary[2][1], 2)) / 2;
            scale[1] = Math.sqrt(Math.pow(boundary[2][0] - boundary[4][0], 2) + Math.pow(boundary[2][1] - boundary[4][1], 2)) / 2;
            return scale;
        }
    }
};
export const getCenter = (boundary) => {
    const minimums = [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY];
    const maximums = [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY];
    if (boundary) {
        for (const coord of boundary) {
            for (let dimension = 0; dimension < 3; dimension++) {
                maximums[dimension] = Math.max(maximums[dimension], coord[dimension]);
                minimums[dimension] = Math.min(minimums[dimension], coord[dimension]);
            }
        }
    }
    const xCenter = (maximums[0] + minimums[0]) / 2;
    const yCenter = (maximums[1] + minimums[1]) / 2;
    const zCenter = 0;
    return [xCenter, yCenter, zCenter];
};
export const getSelectionCenter = (boundary) => {
    const minimums = [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY];
    const maximums = [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY];
    if (boundary) {
        for (const coord of boundary) {
            for (let dimension = 0; dimension < 3; dimension++) {
                maximums[dimension] = Math.max(maximums[dimension], coord[dimension]);
                minimums[dimension] = Math.min(minimums[dimension], coord[dimension]);
            }
        }
    }
    const xCenter = (maximums[0] + minimums[0]) / 2;
    const yCenter = (maximums[1] + minimums[1]) / 2;
    const zCenter = 0;
    return [xCenter, yCenter, zCenter];
};
export const getRotationMarkerPosition = (selectionScale, selectedEntityIds, editorRotations, contentRotations, scale, zoomAdjFactor, center) => {
    if (!selectionScale)
        return null;
    const rotation = selectedEntityIds.length === 1 ? editorRotations[selectedEntityIds[0]] || contentRotations[selectedEntityIds[0]] : [0, 0, 0]; // group selections are never rotated
    const theta = ((rotation?.[2] ?? 0) * Math.PI) / 180;
    const sfX = Math.abs(scale[0]) + 0.6 * zoomAdjFactor;
    const sfY = Math.abs(scale[1]) + 0.6 * zoomAdjFactor;
    //const sfz = scale[2] + 1.2;
    const x5 = -sfX * Math.cos(theta) + sfY * Math.sin(theta) + center[0];
    const y5 = -sfX * Math.sin(theta) - sfY * Math.cos(theta) + center[1];
    return [x5, y5, 0.05];
};
